export const PERIODO_MAP: { [key: number]: string } = {
  1: '1m',
  2: '5m',
  3: '15m',
  4: '30m',
  5: '1h',
  6: '1d',
  7: '4h',
  8: '1w'
};

export function formatPeriodo(periodo: any): string {
  if (periodo === null || periodo === undefined) return '';
  const n = Number(periodo);
  if (!isNaN(n) && PERIODO_MAP[n]) return PERIODO_MAP[n];
  if (isNaN(n)) return String(periodo);
  if (n <= 0) return String(periodo);
  if (n >= 60) {
    const hours = n / 60;
    if (Number.isInteger(hours)) return `${hours}h`;
    return `${n}m`;
  }
  return `${n}m`;
}

export function periodoToTimeframe(id: number): string {
  return PERIODO_MAP[id] ?? PERIODO_MAP[6];
}

export function anyTrueCsv(value: string | null | undefined): boolean {
  return !!value && value.split(',').some(v => v.trim() === 'true');
}

export function formatPeriodoCsv(value: string | null | undefined): string {
  if (!value) return '';
  return value.split(',').map(v => formatPeriodo(v.trim())).join(', ');
}

const PERIODO_DURATION_MINUTES: { [key: number]: number } = {
  1: 1, 2: 5, 3: 15, 4: 30, 5: 60, 6: 1440, 7: 240, 8: 10080
};

export function fastestCsv(value: string | null | undefined): string {
  if (!value) return '';
  const tokens = value.split(',').map(v => v.trim()).filter(v => v !== '');
  if (tokens.length === 0) return '';
  return tokens.reduce((fastest, current) => {
    const durFastest = PERIODO_DURATION_MINUTES[Number(fastest)] ?? Infinity;
    const durCurrent = PERIODO_DURATION_MINUTES[Number(current)] ?? Infinity;
    return durCurrent < durFastest ? current : fastest;
  });
}
